/**
 * 51esc web — entry point: `/greenie-board.html`.
 *
 * Greenie Board (Fase 5g.3): tablero de apontajes en portaaviones del
 * escuadrón. Una fila por piloto verificado; cada fila es una tira
 * cronológica de pases (cuadros de color por calificación LSO).
 *
 * Consume `GET /api/greenie-board` (Fase 5g.2). Se llega desde la
 * pizarra de la ready room en `/portaaviones.html`.
 */

import { mountGreenieBoard } from './modules/greenie-board/mount.js';

void mountGreenieBoard();
